// Розбір XML ПН/РК (текст, уже декодований з windows-1251): поля шапки й тіла та рядки розділу Б.
// Значення — дослівно, як у документі (без перетворень): з них будується бланк (lib/pn/form.js).

const unesc = (s) => s.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&amp;/g, "&");

export function parsePnXml(xml) {
  const fields = {};
  // Перше входження кожного простого тегу (без ROWNUM)
  for (const m of xml.matchAll(/<([A-Z][A-Z0-9_]*)(\s[^>]*?)?(?:\/>|>([^<]*)<\/\1>)/g)) {
    const [, tag, attrs = "", val] = m;
    if (tag.startsWith("RXXXX") || attrs.includes("ROWNUM") || tag in fields) continue;
    fields[tag] = attrs.includes("nil") || val == null ? "" : unesc(val.trim());
  }
  const rows = new Map();
  for (const m of xml.matchAll(/<RXXXX([A-Z0-9_]+)\s+ROWNUM="(\d+)"([^>]*?)(?:\/>|>([\s\S]*?)<\/RXXXX\1>)/g)) {
    const [, field, num, attrs, val] = m;
    if (!rows.has(num)) rows.set(num, {});
    rows.get(num)[field] = attrs.includes("nil") ? "" : unesc((val ?? "").trim());
  }
  const items = [...rows.entries()].sort((a, b) => Number(a[0]) - Number(b[0])).map(([n, f]) => ({ n, ...f }));
  const cdoc = `${fields.C_DOC || ""}${fields.C_DOC_SUB || ""}${fields.C_DOC_VER || ""}`;
  return { cdoc, fields, rows: items };
}
